export default {
    namespaced: true,
    state: () => ({
        open: false,
        tier: null, // 'base' | 'vip'
    }),
    mutations: {
        show(state, { tier } = {}) {
            state.open = true;
            state.tier = tier || 'base';
        },
        hide(state) {
            state.open = false;
        },
    },
    actions: {
        show({ commit }, payload) {
            commit('show', payload);
        },
        hide({ commit }) {
            commit('hide');
        },
    },
};

